module.exports = __webpack_public_path__ + "static/media/babynatural.9b251612.jpg";